import moment from 'moment-timezone';
/////////////////////////////////////
/** Server times shown in the viewer's time zone and the site language (see `applySiteLanguage`). */
class CreateTime {
    constructor() {
        this.timeZone = moment.tz.guess();
    }
    setDate(utc) {
        this.time = moment.utc(utc).tz(this.timeZone);
        this.seconds = moment().diff(this.time, 'seconds');
        this.fromNow = this.time.fromNow();
        return this;
    }

    /** "5 minutes" (no "ago"). */
    get ago() {
        return this.time.fromNow(true);
    }

    /** Messages under an hour old group together. */
    get agoMinute() {
        return this.seconds < 3600 ? "minutes" : this.fromNow;
    }

    /** "5 hours ago" today, else the date and time. */
    get toNow() {
        return this.seconds < 86400 ? this.fromNow : this.time.format("D MMM, LT");
    }

    /** Just the time today, else the full date. */
    get toDay() {
        return this.seconds < 86400 ? this.time.format("LT") : this.fullDate;
    }

    get fullDate() {
        return this.time.format("dddd, D MMM YYYY, LT");
    }
}

export default new CreateTime();
